module.exports = __webpack_public_path__ + "media/images/phone-white-c73e55cfc88daae64c971106b652cf7d.png";